<template>
  <v-container v-if="!loading && food">
    <v-layout row>
      <v-flex xs12>
        <h4>You are reviewing {{ food.name }}</h4>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs12 sm8>
        <v-card>
          <v-img v-if="food.photos" :src="imageSrc(food)" height="300px">
          </v-img>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout row class="mt-5">
      <v-flex xs12 sm6>
        <h3>Overall Rating</h3>
        <star-rating
          v-model="rating"
          :read-only="showThankYou"
          :rating="rating"
        ></star-rating>
      </v-flex>
      <v-flex xs12 sm6 v-if="updatedTime">
        Review Date: <span>{{ updatedTime | moment('from') }}</span>
      </v-flex>
    </v-layout>
    <v-layout row class="mt-3">
      <v-flex xs12 sm7>
        <v-text-field
          multi-line
          name="review"
          rows="2"
          placeholder="Few words about this dish"
          label="Public Review"
          id="review"
          :readonly="showThankYou"
          v-model="publicComment"
        >
        </v-text-field>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex>
        <v-btn
          dark
          color="info darken-3"
          :disabled="showThankYou"
          @click.stop="submitReview"
          >Submit</v-btn
        >
      </v-flex>
    </v-layout>
    <v-layout v-if="showThankYou">
      <h3>Thank you for your review</h3>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      publicComment: null,
      rating: null,
      updatedTime: null,
      showThankYou: false
    }
  },
  computed: {
    ...mapGetters({
      user: 'user',
      food: 'food',
      review: 'review',
      loading: 'loading'
    }),
    imageUrl() {
      return this.food && this.food.photos && this.food.photos.length > 0
        ? this.food.photos[0].imageUrl
        : null
    }
  },
  mounted() {
    let foodId = this.$route.params.food_id
    let orderId = this.$route.params.order_id
    this.$store.dispatch('findById', foodId)
    this.$store.dispatch('loadDishReview', { foodId, orderId }).then(data => {
      if (data) {
        this.rating = data.rating
        this.publicComment = data.publicComment
        if (data.updatedTime) {
          this.updatedTime = new Date(data.updatedTime)
        }
      }
    })
  },
  methods: {
    submitReview() {
      let product_id = this.$route.params.food_id
      let product_ids = [product_id]
      
      // needs work
      let review = {
        products_ratings: {
           [product_id]: {
             overall: this.rating
          }
        },
        orderId: this.$route.params.order_id,
        publicComment: this.publicComment,
        product_ids: product_ids
      }
      this.$store.dispatch('saveDishReview', review).then(() => {
        this.showThankYou = true
      })
      console.log('Submitting review', review)
    },
    imageSrc(dish) {
      if (dish.photos) {
        if (dish.photos.length > 0 && dish.photos[0] !== undefined) {
          return dish.photos[0].imageUrl
        }
        if (dish.photos.length > 0 && dish.photos[1] !== undefined) {
          return dish.photos[1].imageUrl
        }
      }
      return null
    }
  }
}
</script>
